import { render } from "./ConfigurationView.vue?vue&type=template&id=6c5e49ac&scoped=true"
import script from "./ConfigurationView.vue?vue&type=script&lang=js"
export * from "./ConfigurationView.vue?vue&type=script&lang=js"

import "./ConfigurationView.vue?vue&type=style&index=0&id=6c5e49ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5e49ac"]])

export default __exports__